import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ConfigService } from './config.service';
// import { User } from './user/user.type';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public baseUrl!: String;

  urlParams: string = '';
  isIos = false;
  appConfigObj: any = {}


  loginStatus: any;
  selectedShop: any;
  cartCount = 0;

  sellerId = 0;

  cartSubject = new Subject();
  parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(public http: HttpClient,
    private router: Router,
    private commonConfigService: ConfigService) {
      this.baseUrl = this.commonConfigService.getBaseUrl();
    
  }

  // useit for dijipikari admins others willbe removed soon
  public getRealUserData() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? "{}");
  }

  // useit for dijipikari admins others willbe removed soon
  public getSelecterUserData() {
    return JSON.parse(localStorage.getItem("SelectedUser") ?? "{}");
  }

  private getLogindetails() {
    this.loginStatus = localStorage.getItem('inventory_loginStatus') ? JSON.parse(localStorage.getItem('inventory_loginStatus')) : [];
  }

  private getSelectedShop() {
    this.selectedShop = localStorage.getItem('selectedShop') ? JSON.parse(localStorage.getItem('selectedShop')) : [];
  }

  public getSelectedStaff() {
    return this.selectedShop = localStorage.getItem('selectedUser') ? JSON.parse(localStorage.getItem('selectedUser')) : {};
  }

  public getUserdetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? "{}");
  }

  public getSelectedUser() {
    return JSON.parse(localStorage.getItem('SelectedUser'));
  }

  // public getPreOrders(sendingParam) {



  //   const ParseHeaders = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   };

  //   var sendingData = {
  //     ShopID: sendingParam.ShopID,
  //     SellerID: (this.getUserdetails().IsShop) ? this.getUserdetails().ParentEcomSellerID : this.getUserdetails().EcomSellerID,
  //     IsDateCheck: sendingParam.IsDateCheck,
  //     FromTime: sendingParam.FromTime,
  //     ToTime: sendingParam.ToTime,
  //     AssignedUser: this.getSelectedStaff().UserID,
  //     OrderStatus: sendingParam.OrderStatus,
  //   };

  //   console.log("se data : ", sendingData)
  //   var url = this.baseUrl + '/api/Order/GetPreOrders';

  //   return this.http.post(url, sendingData, ParseHeaders)

  // }


  getOfferImages() {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };


    var url = this.baseUrl + '/api/Order/GetOfferImges?OfferFor=' + 'mobile' + '&SellerID=' + this.sellerId;

    return this.http.post(url, ParseHeaders)
  }

  public getProducts(takeAll: boolean = false, skip: number, take: number, categoryId?: number, searchKeyword?: string) {
    let userDetails = this.getUserdetails();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      CategoryID: categoryId,
      Keyword: searchKeyword,
      TakeAll: takeAll,
      Skip: skip,
      Take: take,
      SellerID: 0,
      // userId: userID,
      ProductsFor: "admin"
    };

    var url = this.baseUrl + '/api/Products/GetProducts';
    return this.http.post(url, sendingData, ParseHeaders)

  }

  deleteCartItem(item) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      ID: item,
    };

    var url = this.baseUrl + '/api/Order/DeleteCart';
    return this.http.post(url, sendingData, ParseHeaders)
  }


  public saveSalesReturn(items) {

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var url = this.baseUrl + '/api/Order/SaveSalesReturnDetailsForShop';

    return this.http.post(url, items, ParseHeaders)

  }


  public getProductCategories() {
    this.getLogindetails()
    let userDetails = this.getUserdetails();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // var sendingData = {
    //   BranchID: this.loginStatus.BranchID
    // };

    var url = this.baseUrl + '/api/Products/GetCategories?SellerID=' + 0;
    return this.http.get(url, ParseHeaders)
  }




  public addPreorders(sendingParams) {
    this.getLogindetails()
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = sendingParams
    var url = this.baseUrl + '/api/Order/AddPreOrders';
    return this.http.post(url, sendingData, ParseHeaders)
  }

  public addToDistributionCart(item) {

    this.getLogindetails();
    this.getSelectedShop();

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var sendingData = {
      ProductID: item.ID,
      OrderedQuantity: item.NewProdQty ? item.NewProdQty : 1,
      Price: item.Price,
      CreatedBy: this.loginStatus.UserID,
      OrderStatus: item.OrderStatus ? item.OrderStatus : "generated",
      OrderState: "Active",
      SellerID: (this.loginStatus.IsShop) ? this.loginStatus.ParentEcomSellerID : this.loginStatus.EcomSellerID,
      ForShopID: this.selectedShop.BranchID,
      ForShopName: this.selectedShop.ShopName,
      ExpectedDeliveryDate: item.ExpectedDeliveryDate,
      AssignedUser: this.getSelectedStaff().UserID,
      AssignedUserName: this.getSelectedStaff().Name,
      PurchasePrice: 0,
      SalePrice: 0,
      ProductName: item.ProductName,
      HistoryData: item.HistoryData,
      CheckPrice: item.CheckPrice,
      ProductImages: item.ProductImages,
      RequestedGroupQty: item.RequestedGroupQty,
      PurchasedGroupQty: item.PurchasedGroupQty,
      IsGroup: item.IsGroup,
      PurchasedQuantity: item.PurchasedQuantity
    };

    var url = this.baseUrl + '/api/Order/AddPreOrders';

    return this.http.post(url, sendingData, ParseHeaders)

  }
  public deletePreOrder(params) {

    this.getLogindetails();

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var sendingData = {
      ID: params.ID,
      UpdatedBy: this.loginStatus.UserID,
      UpdatedOn: new Date(),
      ProductID: 0,
      HistoryData: params.HistoryData
    }

    var url = this.baseUrl + '/api/Order/DeletePreOrderItem';

    return this.http.post(url, sendingData, ParseHeaders)

  }
  public updateDistributionCart(item) {

    this.getLogindetails();
    this.getSelectedShop();

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var sendingData = {
      ID: item.ID,
      ProductID: item.ProductID,
      OrderedQuantity: item.OrderedQuantity,
      PurchasedQuantity: item.PurchasedQuantity,
      PurchasePrice: item.PurchasePrice,
      SalePrice: item.SalePrice,
      UpdatedBy: item.UpdatedBy,
      OrderStatus: item.OrderStatus,
      SellerID: item.SellerID,
      ForShopID: item.ForShopID,
      ForShopName: item.ForShopName,
      ExpectedDeliveryDate: item.ExpectedDeliveryDate,
      AssignedUser: item.AssignedUser,
      AssignedUserName: item.AssignedUserName,
      OrderState: item.OrderState,
      ProductName: item.ProductName,
      HistoryData: item.HistoryData,
      PurchaseDate: item.PurchaseDate,
      SalesDate: item.SalesDate,
      SalesReturnDate: item.SalesReturnDate,
      PurchaseReturnDate: item.PurchaseReturnDate,
      CheckPrice: item.CheckPrice,
      ProductImages: item.ProductImages,
      IsGroup: item.IsGroup,
      RequestedGroupQty: item.RequestedGroupQty,
      PurchasedGroupQty: item.PurchasedGroupQty,
      GroupCount: item.GroupCount,
      OrderID: item.OrderID,
      OrderNumber: item.OrderNumber,
      IsCloned: item.IsCloned
    };

    var url = this.baseUrl + '/api/Order/UpdatePreOrders';

    return this.http.post(url, sendingData, ParseHeaders)

  }


  public updateCheckPrice(items) {

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var url = this.baseUrl + '/api/Order/UpdatePreOrderDetailsByCheckPrice';

    return this.http.post(url, items, ParseHeaders)
  }

  public approvePreOrder(params) {

    this.getLogindetails();

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var url = this.baseUrl + '/api/Order/ApprovePreOrders';

    return this.http.post(url, params, ParseHeaders)
  }

  public adminLogin(params) {
    let sendingData = {
      "UserName": params.UserName,
      "Password": params.Password,
      "UserType": "admin"
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/User/AdminLogin';
    return this.http.post(url, sendingData, ParseHeaders)
  }


  //New Apis ECOM CORE
  public Login(params) {
    let sendingData = {
      "UserName": params.UserName,
      "Password": params.Password,
      // "SellerId": this.sellerId
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var url = this.baseUrl + '/api/User/LoginUser';
    return this.http.post(url, sendingData, ParseHeaders)
  }

  public RegisterUser(params) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let sendingData = {
      firstName: params.name,
      // "email": "",
      // "lastName": "",
      mobileNo: params.phonenumber,
      // "location": "",
      username: params.phonenumber,
      password: params.password,
      sellerID: this.sellerId,
      // "referenceNumber": "",
      userType: 'user',
      promotionalCode: params.code
    }
    var url = this.baseUrl + '/api/User/RegisterUserWithLedgerIntegration';
    return this.http.post(url, sendingData, ParseHeaders)
  }


  public ResetPassword(params) {
    this.getLogindetails();

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let sendingData = {
      Password: params.Password,
      PhoneNumber: params.Username
    }

    var url = this.baseUrl + '/api/User/ResetPassword';

    return this.http.post(url, sendingData, ParseHeaders)
  }
  public GenerateOTP(phonenumber) {
    let tempBaseUrl = this.baseUrl //change later if necessory
    var url = tempBaseUrl + '/Order/GenerateOTP?PhoneNumber=' + phonenumber;
    return this.http.get(url, this.parseHeaders)
  }


  public resetPassword(params) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/User/ResetPasswordUsingOTP'
    var sendingData = {
      otp: params.otp,
      password: params.password,
      phoneNumber: params.phonenumber
    }
    return this.http.post(url, sendingData, ParseHeaders);
  }

  public getEditprofile() {

    let selectedUser = this.getSelectedUser()

    let url = this.baseUrl + '/api/User/GetUserProfile'
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      userID: selectedUser.ID,
      directBuyNo: 0,
      sellerID: this.sellerId,
      organisationID: 0

    };

    return this.http.post(url, sendingData, ParseHeaders)
  }
  public updateUserdetails(params) {
    let useriD = this.getSelectedUser()
    // this.getSelectedUser=useriD


    let url = this.baseUrl + '/api/User/UpdateUser'
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })

    };

    var sendingData = {

      id: useriD.ID,
      ssdToken: "",
      organisationID: 0,
      email: params.emailid,
      updatedBy: useriD.ID,
      firstName: params.firstname,
      lastName: params.lastname,
      mobileNo: params.phonenumber,
      location: ""

    }
    return this.http.post(url, sendingData, ParseHeaders)

  }

  public generatePromotionalCode() {
    var url = this.baseUrl + '/api/Order/GeneratePromotionalCode?SellerId=' + this.sellerId;
    return this.http.get(url, this.parseHeaders)
  }

  public getPromotionalCodes() { //yest
    var sendingData = {
      promotionalCode: "",
      sellerID: this.sellerId
    }
    var url = this.baseUrl + '/api/Order/GetPromotionalCodes';
    return this.http.post(url, sendingData, this.parseHeaders)
  }

  public addPromotionalCode(params) {
    const userId = this.getSelectedUser();
    var sendingData = {
      promotionalCode: params.promotionalcode,
      discountPercentage: params.discount,
      sellerID: this.sellerId,
      createdBy: userId.ID,
      validFrom: params.validFrom,
      validTo: params.validTo,
      codeFor: "",
      connectedPhoneNumber: params.phonenumber,
      connectedCustomerName: params.name
    }
    var url = this.baseUrl + '/api/Order/AddPromotionalCode';
    return this.http.post(url, sendingData, this.parseHeaders)
  }

  public editPromotionalCode(params) {
    const userId = this.getSelectedUser();
    var sendingData = {
      id: params.id,
      promotionalCode: params.promotionalcode,
      discountPercentage: params.discount,
      sellerID: this.sellerId,
      createdBy: userId.ID,
      validFrom: params.validFrom,
      validTo: params.validTo,
      codeFor: "user",
      connectedPhoneNumber: params.phonenumber,
      connectedCustomerName: params.name
    }
    var url = this.baseUrl + '/api/Order/UpdatePromotionalCode';
    return this.http.post(url, sendingData, this.parseHeaders)
  }
  public getAddressuser() {
    let selecteduser = this.getSelectedUser();

    let url = this.baseUrl + '/api/Order/GetDeliveryAddressByUser'

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {

      userID: selecteduser.ID,
      directBuyNo: 0,
      sellerID: this.sellerId,
      organisationID: 0
    };
    return this.http.post(url, sendingData, ParseHeaders)
  }

  public getAddressbyUserId(params) {

    let url = this.baseUrl + '/api/Order/GetDeliveryAddressByID'
    let user = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {

      id: params
    };
    return this.http.post(url, sendingData, ParseHeaders)
  }
  public createUserAddress(params) {
    let selecteduser = this.getSelectedUser();

    let url = this.baseUrl + '/api/Order/CreateUserAddress'

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      userID: selecteduser.ID,
      customerName: params.name,
      customerPhone: "",
      deliveryAddress: params.Address,
      deliveryPlace: "",
      deliveryLandMark: "",
      deliveryPincode: params.Pincode,
      createdBy: selecteduser.ID

    };
    return this.http.post(url, sendingData, ParseHeaders)
  }


  public deleteUserAddress(params) {
    let selecteduser = this.getSelectedUser();
    let url = this.baseUrl + '/api/Order/DeleteUserAddress'

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {

      id: params,
      updatedBy: selecteduser.ID
    };
    return this.http.post(url, sendingData, ParseHeaders)
  }


  public updateUserAddress(params) {
    let selecteduser = this.getSelectedUser();

    let url = this.baseUrl + '/api/Order/UpdateUserAddress'
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      id: params.id,
      userID: selecteduser.ID,
      customerName: params.name,
      customerPhone: params.customerPhone,
      deliveryAddress: params.Address,
      deliveryPlace: params.deliveryPlace,
      deliveryLandMark: params.deliveryLandMark,

      deliveryPincode: params.Pincode,
      updatedBy: selecteduser.ID
    };
    return this.http.post(url, sendingData, ParseHeaders)

  }


  public changePassword(params) {
    let selectedUser = this.getSelectedUser();
    let userDetails = this.getUserdetails();
    let url = this.baseUrl + '/api/User/ChangePassword';
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      userId: selectedUser.ID,
      password: params.newPsw,
      oldPassword: params.oldPsw,
      updatedBy: userDetails.ID
    }
    return this.http.post(url, sendingData, ParseHeaders);
  }

  public compareOTP(params) {

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var url = this.baseUrl + '/api/Order/CompareOTP?PhoneNumber=' + params.PhoneNumber + '&OTP=' + params.OTP;

    return this.http.get(url, ParseHeaders)
  }


  public GenerateOTPWithSeller(params) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var url = this.baseUrl + '/api/Order/GenerateOTPWithSeller?PhoneNumber=' + params.PhoneNumber + '&SellerName=Digikari';
    return this.http.get(url, ParseHeaders)
  }


  updateCartItem(params) {
    let userDetails = this.getUserdetails();

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = [{
      ID: params.ID,
      ProductID: params.ProductID,
      Price: params.Price,
      Quantity: params.Quantity,
      UpdatedBy: userDetails.ID
    }]

    var url = this.baseUrl + '/api/Order/UpdateCart';
    return this.http.post(url, sendingData, ParseHeaders);
  }

  addToCart(product) {


    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var sendingData = {
      UserID: selectedUser.ID,
      ProductID: product.ID,
      Price: product.FinalPrice,
      Quantity: product.quantity,
      SellerID: this.sellerId,

    }
    var url = this.baseUrl + '/api/Order/AddCart'
    return this.http.post(url, sendingData, ParseHeaders);

  }

  setCount() {
    this.getUserCart().subscribe((res: any) => {
      var cartLength = res.ResponseData.length;
      this.cartSubject.next(cartLength);
    })

  }

  getCount() {
    return this.cartSubject.asObservable();
  }

  public getUserCart() {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {


      UserID: selectedUser.ID,
      SellerID: this.sellerId,
      DirectBuyNo: 0
    }

    var url = this.baseUrl + '/api/Order/GetUserCart';

    return this.http.post(url, sendingData, ParseHeaders)
  }




  getOrderDetails(ID) {

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var sendingData = {
      SellerID: this.sellerId,
      ID: ID
    }
    var url = this.baseUrl + '/api/Order/GetOrderDetails';
    return this.http.post(url, sendingData, ParseHeaders)
  }

  getAllUserOrders(searchStr?: string) {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      takeAll: true,
      skip: 0,
      take: 0,
      isDateChecked: false,
      fromDate: "",
      toDate: "",
      sellerId: this.sellerId,
      keyWord: searchStr,
      orderStatus: "",
      userID: selectedUser.ID,
      directBuyNo: 0,
      unknownUserKey: "",
      saleType: "",
    }
    var url = this.baseUrl + '/api/Order/GetAllOrders';
    return this.http.post(url, sendingData, ParseHeaders);
  }


  getOrderList() {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      UserID: selectedUser.ID,
      SellerID: this.sellerId,
      OrganisationID: 0
    }
    var url = this.baseUrl + '/api/Order/GetAllOrdersByUser';
    return this.http.post(url, sendingData, ParseHeaders)
  }

  getReturnList() {
    let selectedUser = this.getSelectedUser();
    var id = selectedUser.ID
    let url = this.baseUrl + '/api/Return/GetUserReturnList?userId='
    return this.http.get(url + id + '&sellerId=' + this.sellerId)
  }
  getReturnDetails(orderId: number) {
    var id = orderId
    let url = this.baseUrl + '/api/Return/GetUserReturnList?orderId='
    return this.http.get(url + id + '&sellerId=' + this.sellerId)
  }
  getAllReturns() {
    let url = this.baseUrl + '/api/Return/GetUserReturnList?userId='
    return this.http.get(url + 0 + '&sellerId=' + this.sellerId)
  }

  getProductDetails(productId: number) {
    let selectedUser = this.getSelectedUser();
    const userID = selectedUser?.ID ?? 0;
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      ID: productId,
      SellerID: this.sellerId,
      UserID: userID
    }
    var url = this.baseUrl + '/api/Products/GetProductDetailsVTwo';
    return this.http.post(url, sendingData, ParseHeaders)
  }


  // checkout page

  getDeliveryAddressByUser() {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      UserID: selectedUser.ID,
      SellerID: this.sellerId,

    }
    var url = this.baseUrl + '/api/Order/GetDeliveryAddressByUser';
    return this.http.post(url, sendingData, ParseHeaders)

  }

  createuserAddress(params) {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {

      UserID: selectedUser.ID,
      CustomerName: params.UserName,
      DeliveryAddress: params.Address,
      CustomerPhone: params.userPhone,
      DeliveryPlace: params.userPlace,
      DeliveryLandMark: params.userLandmark,
      DeliveryPincode: params.Pincode,
    }


    var url = this.baseUrl + '/api/Order/CreateUserAddress';
    return this.http.post(url, sendingData, ParseHeaders)

  }
  public saveWishlist(params) {
    const userId = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {

      // id: params,
      productId: params,
      userId: userId.ID,
      sellerId: this.sellerId


    }
    var url = this.baseUrl + '/api/UserWishList/SaveUserWishList';
    return this.http.post(url, sendingData, ParseHeaders)
  }
  public getUserWishList() {
    const user = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {


      userID: user.ID,
      directBuyNo: 0,
      sellerID: this.sellerId,
      organisationID: 0



    }
    var url = this.baseUrl + '/api/UserWishList/GetUserWishList';
    return this.http.post(url, sendingData, ParseHeaders)
  }
  public deleteUserWishList(params) {

    let userDetails = this.getUserdetails();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {


      id: params,
      updatedBy: userDetails.ID



    }
    var url = this.baseUrl + '/api/UserWishList/DeleteUserWishList';
    return this.http.post(url, sendingData, ParseHeaders)
  }





  checkoutOrder(param) {
    let userDetails = this.getUserdetails();
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      UserID: selectedUser.ID,
      BillNo: "",
      TotalAmount: param.TotalAmount,
      ExpDeliveryDate: "",
      DeliveryType: "",
      CustomerName: param.CustomerName,
      CustomerPhone: selectedUser.MobileNo,
      DeliveryAddress: param.DeliveryAddress,
      DeliveryPlace: param.DeliveryPlace,
      DeliveryLandMark: param.DeliveryLandMark,
      DeliveryPincode: param.DeliveryPincode,
      OrderStatus: "",
      OrderDetails: "",
      CreatedBy: userDetails.ID,
      CreatedOn: new Date(),
      UpdatedBy: userDetails.ID,
      UpdatedOn: new Date(),
      ItemsCount: param.ItemsCount,
      DirectBuyNo: 0,
      SellerID: this.sellerId,
      AppliedDiscount: 0,
      ReferencePhoneNumber: ""
    }
    var url = this.baseUrl + '/api/Order/CheckOutOrder';
    return this.http.post(url, sendingData, ParseHeaders)
  }


  UpdateOrder(header, addedProducts, modifiedProducts, deletedProducts) {
    let userDetails = this.getUserdetails();
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    var sendingData = {

      "modifiedDetails": [],
      "deletedDetails": [],
      "addedDetails": [],

      "id": header.OrderID,
      "userID": selectedUser.ID,
      "billNo": null,
      "totalAmount": header.TotalAmount,
      "expDeliveryDate": header.ExpDeliveryDate,
      "deliveryType": header.DeliveryType,
      "customerName": header.CustomerName,
      "deliveryAddress": header.DeliveryAddress,
      "deliveryPlace": null,
      "deliveryLandMark": header.DeliveryLandMark,
      "deliveryPincode": header.DeliveryPincode,
      "orderStatus": header.OrderStatus,
      "updatedBy": userDetails.ID,
      "updatedOn": new Date(),
      "customerPhone": header.CustomerPhone,
      "appliedPromocode": null,
      "appliedDiscount": header.AppliedDiscount,
      "referalPhoneNumber": header.ReferalPhoneNumber,
      "paymentStatus": header.PaymentStatus,
      "paymentType": null,
      "paymentDate": null,
      "paymentTransactionId": null,
      "jobNumber": null,
      "totalParts": null,
      "partsUsed": null,
      "partsStatus": null,
      "directOrder": null,
      "isUsedDevice": null,
      "customerID": 0,
      "sellerID": this.sellerId
    }
    modifiedProducts.forEach(element => {
      sendingData.modifiedDetails.push({
        "detailId": element.orderdetailID,
        "productID": element.ProductID,
        "quantity": element.Quantity,
        "price": element.Price,
        "mrp": element.MRP,
        "totalPrice": element.TotalPrice,
        "purchasePrice": null
      })
    });
    addedProducts.forEach(element => {
      sendingData.addedDetails.push({
        "detailId": element.orderdetailID,
        "productID": element.ProductID,
        "quantity": element.Quantity,
        "price": element.Price,
        "mrp": element.MRP,
        "totalPrice": element.TotalPrice,
        "purchasePrice": null
      })
    });
    deletedProducts.forEach(element => {
      sendingData.deletedDetails.push({
        "detailId": element.orderdetailID,
        "productID": element.ProductID,
        "quantity": element.Quantity,
        "price": element.Price,
        "mrp": element.MRP,
        "totalPrice": element.TotalPrice,
        "purchasePrice": null
      })
    });
    var url = this.baseUrl + '/api/Order/UpdateOrder';
    return this.http.post(url, sendingData, ParseHeaders)
  }
  UpdateOrderStatus(params) {
    let userDetails = this.getUserdetails();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      id: params.id,
      // "orderNumber": "string",
      orderStatus: params.orderStatus,
      updatedBy: userDetails.UserID,
      updatedOn: new Date(),
      sellerID: 0,
      TotalAmount: params.totalAmt
    }


    var url = this.baseUrl + '/api/Order/UpdateOrderStatus';
    return this.http.post(url, sendingData, ParseHeaders)

  }

  UpdateReturnStatus(params) {
    let userDetails = this.getUserdetails();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      "id": params.id,
      // "orderNumber": "string",
      "orderStatus": params.orderStatus,
      "updatedBy": userDetails.ID,
      "updatedOn": new Date(),
      "sellerID": this.sellerId,
    }


    var url = this.baseUrl + '/orderreturn'; //add api for order return
    return this.http.post(url, sendingData, ParseHeaders)

  }
  submitReturn(parama, paramb) {
    var returnlist = parama;
    let userDetails = this.getUserdetails();
    let selectedUser = this.getSelectedUser();

    var url = this.baseUrl + '/api/Return/CreateReturnRequest'

    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      orderId: paramb.OrderID,
      products: [],
      userId: selectedUser.ID,
      createdBy: userDetails.CreatedBy,
      sellerId: this.sellerId
    }
    for (let item of returnlist) {
      let data = {
        productId: item.ProductID,
        requestedQty: item.Quantity,
        returnStatus: 'waiting',
        returnDescription: ''
      };
      sendingData.products.push(data);
    }

    return this.http.post(url, sendingData, ParseHeaders)
  }

  getUser(userID?: number) {
    let userDetails = this.getUserdetails()
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var sendingData = {
      sellerID: 0,
      userID: userID,
      userType: 'user',
      keyWord: ''
    }
    let url = this.baseUrl + '/api/User/GetUsers'
    return this.http.post(url, sendingData, ParseHeaders)
  }

  getUsers() {
    let userDetails = this.getUserdetails()
    let sendingData = {
      sellerID: 0,
      userType: 'user',
      keyWord: ''
    }
    let url = this.baseUrl + '/api/User/GetUsersForAdmin'
    return this.http.post(url, sendingData, this.parseHeaders)
  }

  getTransactions() {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/Reports/GetTransactionFromIntegatedAccounts'
    var sendingData =
    {
      takeAll: true,
      skip: 0,
      take: 0,
      customerId: selectedUser.ID,
      sellerId: this.sellerId,
      reportFor: "user"
    }
    return this.http.post(url, sendingData, ParseHeaders)
  }
  getBalance() {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/Reports/GetBalancesFromIntegatedAccounts'
    var sendingData =
    {
      customerId: selectedUser.ID,
      sellerId: this.sellerId,
      reportFor: "user"
    }
    return this.http.post(url, sendingData, ParseHeaders)
  }
  submitTransaction(Amount: any) {
    let selectedUser = this.getSelectedUser();
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/Seller/SaveIntegratedAccountsPayments'
    var sendingData =
    {
      customerId: selectedUser.ID,
      payingAmount: Amount,
      sellerId: this.sellerId,
      createdBy: 0
    }
    return this.http.post(url, sendingData, ParseHeaders);
  }

  getAllOrders() {
    let loginDetails = this.getRealUserData();
    let url = this.baseUrl + '/api/Order/GetAllOrdersByDateWise';
    let sendingData = {
      SellerID: loginDetails.SellerID,
      fromDate: "2022-05-13T09:54:26.497Z",
      toDate: new Date()
    };
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  approveReturn(data: any, orderId: number, userId: number) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/Return/SubmitReturnRequest';
    let productForReturn = [];
    for (let item of data) {
      let prod = {
        productId: item.ProductId,
        requestedQty: item.RequestedQty,
        returnStatus: item.status,
        returnDescription: "",
        isAccepted: (item.status == "Canceled") ? false : true,
        isNew: false
      }
      productForReturn.push(prod);
    }
    var sendingData = {
      sellerID: this.sellerId,
      orderId: orderId,
      userId: userId,
      products: productForReturn,
      createdBy: 0
    }
    return this.http.put(url, sendingData, ParseHeaders);
  }

  public getProductDiscount(product: any): number {
    if (product.MRP > 0) {
      return (((product.MRP - product.FinalPrice) / product.MRP) * 100);
    } else {
      return (((product.UnitPrice - product.FinalPrice) / product.UnitPrice) * 100);
    }
  }

  public checkIsUSerActive() {
    const user = localStorage.getItem('admin_Details');
    const userObj = user ? JSON.parse(user) : null;
    if (userObj && userObj?.ID) {
      let url = this.baseUrl + '/api/User/GetUserStatus';
      let reqBody = {
        "userID": userObj?.ID,
        "directBuyNo": 0,
        "sellerID": 0,
        "organisationID": 0
      };
      return this.http.post(url, reqBody, this.parseHeaders);
    }
  }

  public changeUserStatus(userId: number, status: boolean) {
    let reBody = {
      "id": userId,
      "status": status,
      "updatedBy": 1
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/User/ChangeUserStatus';
    return this.http.post(url, reBody, ParseHeaders);
  }
  public billingAddressStatus(params) {
    let sendingData = {
      id: params,
      updatedBy: 1
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/Order/MakeDefaultBillingAddress';
    return this.http.post(url, sendingData, ParseHeaders);
  }

  public defaultAddressStatus(params) {
    let sendingData = {
      id: params,
      updatedBy: 1
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/Order/MakeDefaultDeliveryAddress';
    return this.http.post(url, sendingData, ParseHeaders);
  }


  public changeUserDiscount(params) {
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/api/User/ChangeUserDiscount';
    return this.http.post(url, params, ParseHeaders);
  }

  public logDevice(userId?: string, uuid?: string) {
    let reqBody = {};
    if (userId && uuid) {
      reqBody = {
        "codeVersion": this.commonConfigService.version,
        "operatingSystem": navigator.platform,
        "userAgent": navigator.vendor,
        "userId": userId,
        "uuid": uuid,
        "branchId": 0,
        "url": window.location.href,
        "appName": "Digikari"
      }
    } else {
      reqBody = {
        "codeVersion": this.commonConfigService.version,
        "operatingSystem": navigator.platform,
        "userAgent": navigator.vendor,
        "url": window.location.href,
        "appName": "Digikari"
      }
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = 'https://servicenear.in/utilities/api/DeviceLog/UserDeviceLog';
    return this.http.post(url, reqBody, ParseHeaders);
  }

  private setUserIdToUuid(uuid) {
    const user = localStorage.getItem('admin_Details');
    const userObj = user ? JSON.parse(user) : null;
    if (userObj && userObj.ID) {
      this.logDevice(userObj.ID, uuid).subscribe();
    }
  }

  public getSetUserIdToUuid() {
    const uuid = localStorage.getItem('UserLogId');
    if (!uuid) {
      this.logDevice().subscribe((res: any) => {
        if (res && res.ResponseData) {
          localStorage.setItem('UserLogId', res.ResponseData);
          this.setUserIdToUuid(res.ResponseData);
        }
      })
    } else {
      this.setUserIdToUuid(uuid);
    }
  }

  public changeStaffUserStatus(userId: number, status: boolean) {
    let reBody = {
      "id": userId,
      "status": status,
      "updatedBy": 1
    }
    const ParseHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let url = this.baseUrl + '/User/DeleteUser';
    return this.http.post(url, reBody, ParseHeaders);
  }
}
